import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { BLOCK_BACKGROUND_PALETTE_KEY, BLOCK_PADDING_TOP_KEY, BLOCK_PADDING_BOTTOM_KEY, } from "@diality/contracts";
import { BlockWrapper } from "./block-wrapper";
import { cn } from "../lib/utils";
import { useBlockRender } from "./context";
import { getBlockEntry } from "./registry";
import { BlockBandProvider } from "../blocks/_section";
/**
 * Renders one stored block via the shared registry — the SAME component the
 * public site uses. The CMS canvas and the web frontend both render through
 * here, so the editor preview is 1:1 with production by construction.
 *
 * `index` is the block's ordered position in the page; it drives the alternating
 * band tone (see {@link BlockBandProvider}). The CMS canvas passes each block's
 * own index so canvas bands match the public site even though canvas blocks are
 * not DOM siblings.
 */
export function BlockRenderer({ block, index, }) {
    const { resolveImage } = useBlockRender();
    const entry = getBlockEntry(block.componentId);
    if (!entry) {
        return (_jsxs("div", { className: cn("border border-dashed border-border bg-muted/30 px-4 py-10 text-center text-sm text-muted-foreground"), children: ["Unknown component: ", block.componentId] }));
    }
    const data = entry.fromBlock(block, resolveImage);
    const Component = entry.Component;
    return (_jsx(BlockBandProvider, { index: index ?? null, children: _jsx(BlockWrapper, { backgroundPalette: block.scalars?.[BLOCK_BACKGROUND_PALETTE_KEY], paddingTop: block.componentId === "ARComponent"
                ? "0"
                : block.scalars?.[BLOCK_PADDING_TOP_KEY], paddingBottom: block.componentId === "ARComponent"
                ? "0"
                : block.scalars?.[BLOCK_PADDING_BOTTOM_KEY], "data-block": true, "data-block-id": block.id, "data-component-id": block.componentId, children: _jsx(Component, { data: data }) }) }));
}
/** Renders an ordered version's blocks top-to-bottom. */
export function PageRenderer({ blocks }) {
    const ordered = [...blocks].sort((a, b) => a.position - b.position);
    return (_jsx(_Fragment, { children: ordered.map((block, i) => (_jsx(BlockRenderer, { block: block, index: i }, block.id))) }));
}
//# sourceMappingURL=block-renderer.js.map